import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import {
  getTitleContentRevealDelayMs,
  StepMotionGroup,
  StepMotionItem,
} from "./step-motion";
import { StepTitle } from "./step-title";

export interface WelcomeStepProps {
  animateItems?: boolean;
  stepNumber: number;
}

export const WelcomeStep = memo(function WelcomeStep({
  animateItems,
  stepNumber,
}: WelcomeStepProps) {
  const title = "Meet Commerce Agent";
  const contentRevealDelayMs = getTitleContentRevealDelayMs(title, true);

  return (
    <Flex dir="column" grow={1} justify="center">
      <StepMotionGroup animateItems={animateItems}>
        <Flex dir="column" gap="lg">
          <StepMotionItem animateItems={animateItems}>
            <Text fontSize="sm" textColor="tertiary">
              Step {stepNumber}
            </Text>
          </StepMotionItem>
          <StepMotionItem animateItems={animateItems}>
            <StepTitle animate={animateItems} scramble text={title} />
          </StepMotionItem>
          <StepMotionItem
            animateItems={animateItems}
            delayMs={contentRevealDelayMs}
          >
            <Text fontSize="lg" textColor="tertiary">
              Commerce Agent is your brand&apos;s AI shopping assistant. It
              helps customers get answers before and after they buy, and will
              reach out at the right moments to start helpful conversations.
            </Text>
          </StepMotionItem>
        </Flex>
      </StepMotionGroup>
    </Flex>
  );
});
